import { applicationApi } from "../../common/api";
import { News } from "./types";

// Define a service using a base URL and expected endpoints
export const newsApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllNews: builder.query<News[], void>({
      query: () => `news`,
      providesTags: [{ type: "News", id: "LIST" }],
    }),
    getNews: builder.query<News, string>({
      query: (query) => `news/${query}`,
    }),
    createNews: builder.mutation<News, any>({
      query: (body) => ({
        url: "/news",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "News", id: "LIST" }],
    }),
    deleteNews: builder.mutation<any, number>({
      query: (id) => ({
        url: `news/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "News", id: "LIST" }],
    }),
    updateNews: builder.mutation<News, any>({
      query: (body) => ({
        url: "/news",
        method: "PATCH",
        body,
      }),
      invalidatesTags: [{ type: "News", id: "LIST" }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAllNewsQuery, useGetNewsQuery, useCreateNewsMutation, useDeleteNewsMutation, useUpdateNewsMutation } = newsApi;
